import { FormContainer, StyledInput, FormButton } from "../../components/Forms";
import { Heading, FlexContainer, Label, WarningText, BasicSpan, BasicText } from "../../components/utilities";
import React, { useRef, useState, useEffect } from "react";
import {
  getAuth,
  createUserWithEmailAndPassword,
  User as AuthUser,
} from "firebase/auth";
import {
  query,
  collection,
  getDocs,
  getFirestore,
  where,
  doc,
  setDoc,
} from "firebase/firestore";
import User from "../../types/User";
interface IProps {
    onClick : () => void;
}

const Signup = ({onClick} : IProps) => {
  const formRef = useRef<HTMLFormElement>(null);
  const [emailAddress, setEmailAddress] = useState("");
  const [fullName, setFullName] = useState("");
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [disabledButton, setDisabledButton] = useState(true);
  const [warningText, setWarningText] = useState("");
  function addUserToDB(user: AuthUser) {
    const userRef = doc(getFirestore(), "users", `${user.uid}`);
    const newUser: User = {
      fullName,
      username,
      user_id: user.uid,
    };
    setDoc(userRef, newUser);
  }
  const signUp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const usersQuery = query(
      collection(getFirestore(), "users"),
      where("username", "==", `${username}`)
    );

    const userDocs = await getDocs(usersQuery);
    if (userDocs.docs.length === 1) {
      setWarningText("Username is taken, please choose another one");
      return;
    }

    try {
      const user = (
        await createUserWithEmailAndPassword(getAuth(), emailAddress, password)
      ).user;
      addUserToDB(user);
    } catch (e: any) {
      setWarningText(
        "Email address is already associated with a fakestagram account"
      );
      return;
    }
  };
  useEffect(() => {
    if (formRef.current?.checkValidity() === true) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [emailAddress, password, username, fullName]);

  return (
    <FormContainer ref={formRef} onSubmit={signUp}>
      <Heading>Media-Player</Heading>
      <FlexContainer direction="column" alignItems="start" gap="0.3rem">
        <Label htmlFor="email">Email Address</Label>
        <StyledInput
          placeholder="Johndoe@gmail.com"
          required
          id="email"
          type="email"
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.currentTarget.value)}
          title="Email address"
        />
      </FlexContainer>
      <FlexContainer direction="column" alignItems="start" gap="0.3rem">
        <Label htmlFor="full name">Full Name</Label>
        <StyledInput
          placeholder="John Doe"
          required
          id="full name"
          value={fullName}
          onChange={(e) =>
            setFullName(e.currentTarget.value.replace(/[^a-zA-Z ]/g, ""))
          }
          title="Full name"
        />
      </FlexContainer>

      <FlexContainer direction="column" alignItems="start" gap="0.3rem">
        <Label htmlFor="username">Username</Label>
        <StyledInput
          placeholder="JohnDoe23"
          required
          id="username"
          value={username}
          onChange={(e) =>
            setUserName(
              e.currentTarget.value.replace(/\s/g, "").replace(/\W/g, "")
            )
          }
          title="Username"
          maxLength={20}
        />
      </FlexContainer>
      <FlexContainer direction="column" alignItems="start" gap="0.3rem">
        <Label htmlFor="password">Password (minimum of 6 characters)</Label>
        <StyledInput
          type="password"
          required
          placeholder="Password"
          id="password"
          value={password}
          minLength={6}
          onChange={(e) => setPassword(e.currentTarget.value)}
          title="Password (minimum of 6 characters)"
        />
      </FlexContainer>
      <WarningText>{warningText}</WarningText>
      <FormButton disabled={disabledButton} type="submit" name="Sign Up">
        Sign up
      </FormButton>
      <BasicText fontWeight="400" fontSize="1.5rem"> Already have an account? <BasicSpan fontSize="1.5rem" fontWeight="bold" onClick={onClick}>Log in</BasicSpan></BasicText>
    </FormContainer>
  );
};

export default Signup;
